import {Button, Card, Form, Input, Spin} from 'antd';
import React from "react";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${this.props.title} Resource`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Form.Item label="Resource name">
              {getFieldDecorator('name', {
                rules: [{required: true, message: 'Name is required!'}],
                initialValue: data && data.name
              })(<Input/>)}
            </Form.Item>

            <Form.Item label="Description">
              {getFieldDecorator('description', {
                rules: [],
                initialValue: data && data.description
              })(<Input/>)}
            </Form.Item>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
